module.exports = __webpack_public_path__ + "45d71b32e4f41d65d16af333a656af24.svg";